type SvgProps = React.SVGProps<SVGSVGElement>;

export const PaperPencil = (props: SvgProps) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
  >
    <path
      d="M1.16651 1.77365C1.16651 1.45367 1.42843 1.19293 1.74985 1.19293H6.41651V5.25795H10.4998V5.84157C10.8417 5.5907 11.2418 5.41591 11.6665 5.33228V4.43682L7.24135 0.0314941H1.74985C0.785014 0.0314941 -0.000152588 0.81314 -0.000152588 1.77365V13.9687H5.24985V12.8073H1.16651V1.77365ZM7.58318 2.01406L9.67501 4.09652H7.58318V2.01406ZM13.4877 6.92984C12.8262 6.2713 11.6735 6.2713 11.0126 6.92984L6.41651 11.5047V13.9687H8.8916L13.4871 9.39382C13.8178 9.06455 13.9998 8.62727 13.9998 8.16154C13.9998 7.6958 13.8178 7.25852 13.4877 6.92984ZM12.6623 8.57211L8.4086 12.8073H7.58318V11.9856L11.8374 7.75097C12.0573 7.53146 12.4418 7.53146 12.6623 7.75097C12.7725 7.86015 12.8332 8.00591 12.8332 8.16154C12.8332 8.31717 12.7725 8.46235 12.6623 8.57211Z"
      fill="currentColor"
    />
  </svg>
);
